// extracted by mini-css-extract-plugin
export default {"tree_box":"Tabs_tree_box__BSnGN","treeStyle":"Tabs_treeStyle__eQ4P6"};